// Copyright (c) Docugami, Inc. All rights reserved.

import { DgButton } from "components/common/DgCommonStyledComponents";
import { useNavigationService } from "hooks/navigationService";
import { AddDocsAutoAssigningCoachmark } from "hooks/UnassignedFilesCoachmarks";
import { BuildType } from "networking/BuildType";
import { useState } from "react";
import { useSelector } from "react-redux";
import { AppState } from "store";
import { isBuildActive } from "store/state_helpers";
import { AutomationId } from "utils/Automation";
import { AddDocsView, AddDocsViewFooter, AddDocsViewHeader } from "./AddDocsView";
import { ExplorerView } from "./ExplorerView";

export const AddDocsExplorerView = (): JSX.Element => {
    const builds = useSelector((state: AppState) => state.organizations.pipelineBuilds.activeBuilds);
    const isClustering = isBuildActive(BuildType.Clustering, builds);
    const [autoAssigning, setAutoAssigning] = useState(isClustering);

    const navService = useNavigationService();

    const closeButton = <DgButton key="add_docs_close" data-automation-id={AutomationId.DocExplorerAddDocsClose} onClick={navService.goBack}>CLOSE</DgButton>
    const footer = (
        <AddDocsViewFooter buttons={[closeButton]} />
    );

    if (autoAssigning) {
        return <ExplorerView
            header={<AddDocsViewHeader onAddMoreDocs={() => setAutoAssigning(false)} />}
            content={<AddDocsAutoAssigningCoachmark />}
            overlays={[]}
            footer={footer}
            telemetryId={'AutoAssigningCoachmark'} />
    }

    return <AddDocsView
        hidePicker={autoAssigning}
        onComplete={() => setAutoAssigning(true)}
        onDismiss={navService.goBack} />
}
